import { apiSlice } from '../../apiSlice';
import type { AsyncJob } from './asyncJobsTypes';

export const asyncJobsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listAsyncJobs: builder.query<AsyncJob[], void>({
      query: () => 'async-jobs/',
      transformResponse: (response: AsyncJob[]) => {
        const now = new Date();
        return response.filter(job => {
          // Report downloads are delivered by email; do not track them in the UI panel.
          if (job.kind === 'report') return false;
          if (!['completed', 'failed'].includes(job.status)) return true;
          if (!job.completed_at) return true;
          const completedAt = new Date(job.completed_at);
          const secondsElapsed = (now.getTime() - completedAt.getTime()) / 1000;
          return secondsElapsed <= 10;
        });
      },
      providesTags: ['AsyncJobs'],
    }),

    getAsyncJob: builder.query<AsyncJob, number>({
      query: (jobId) => `async-jobs/${jobId}/`,
      providesTags: (_, __, jobId) => [{ type: 'AsyncJobs', id: jobId }],
    }),

    downloadAsyncJobResult: builder.query<Blob, number>({
      query: (jobId) => ({
        url: `async-jobs/${jobId}/download/`,
        method: 'GET',
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
  }),
});

export const {
  useListAsyncJobsQuery,
  useGetAsyncJobQuery,
  useLazyGetAsyncJobQuery,
  useDownloadAsyncJobResultQuery,
  useLazyDownloadAsyncJobResultQuery,
  useLazyListAsyncJobsQuery,
} = asyncJobsApiSlice;
